import { api } from "@/services/api";

import { AppSettingModel, PermissionModel } from "../types";

const settingApi = api.injectEndpoints({
  endpoints: (build) => ({
    getAppSettings: build.query<AppSettingModel[], void>({
      query: (payload) => {
        return {
          url: "api/Profile/GetAppSettings",
          method: "get",
          data: payload,
        };
      },
    }),
    updateAppSetting: build.mutation<AppSettingModel[], AppSettingModel[]>({
      query: (payload) => {
        return {
          url: "api/Profile/UpdateAppSetting",
          method: "post",
          data: payload,
        };
      },
    }),
    getPermissions: build.query<PermissionModel[], void>({
      query: (payload) => {
        return {
          url: "api/Profile/GetPermissions",
          method: "get",
          data: payload,
        };
      },
    }),
    addEditPermission: build.mutation<PermissionModel[], PermissionModel[]>({
      query: (payload) => {
        return {
          url: "api/Profile/AddEditPermission",
          method: "post",
          data: payload,
        };
      },
    }),
  }),
  overrideExisting: false,
});

export const {
  useLazyGetAppSettingsQuery,
  useUpdateAppSettingMutation,
  useLazyGetPermissionsQuery,
  useAddEditPermissionMutation,
} = settingApi;

export default settingApi;
